module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG251a106a920e59378ceee9ded7ea2c9d.251a106a.png";